module.exports = __webpack_public_path__ + "static/media/2.6f5615b4.svg";